import { render, staticRenderFns } from "./Webphone.vue?vue&type=template&id=24023130"
import script from "./Webphone.vue?vue&type=script&lang=ts"
export * from "./Webphone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports